import { css } from 'styled-components';
export default {
    inView: {
        threshold: 0.25,
        rootMargin: '0px 0px -25% 0px',
        earlyRootMargin: '0px 0px -10% 0px',
    },
    globalThreshold: 0.25,
    easeInOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    primary: 'cubic-bezier(0.45, .01, 0.1, 1)',
    secondary: 'cubic-bezier(0.3, 0, 0.7, 1)',
    sharp: 'cubic-bezier(0, 0, 0.1, 1)',
};
export const slideInUpInitial = css `
  > span {
    opacity: 0;
    transform: translateY(100%);
  }
`;
export function slideInUp(animate, duration, delay, easingFunc) {
    return css `
    overflow: hidden;

    > span {
      display: inline-block;
      transition: transform ${duration}ms ${delay}ms ${easingFunc},
        opacity ${duration}ms ${delay}ms ${easingFunc};
    }

    ${animate
        ? css `
          > span {
            opacity: 1;
            transform: translateY(0px);
          }
        `
        : css `
          ${slideInUpInitial};
        `}
  `;
}
export function fadeInUp(animate, amount, duration, delay, easingFunc) {
    return css `
    transition: transform ${duration}ms ${delay}ms ${easingFunc},
      opacity ${duration}ms ${delay}ms ${easingFunc};

    ${animate
        ? css `
          opacity: 1;
          transform: translateY(0px);
        `
        : css `
          opacity: 0;
          transform: translateY(${amount}px);
        `}
  `;
}
export function fadeIn(animate, duration, delay, easingFunc) {
    return css `
    transition: opacity ${duration}ms ${delay}ms ${easingFunc};

    ${animate
        ? css `
          opacity: 1;
        `
        : css `
          opacity: 0;
        `}
  `;
}
